export const modalComponent = state => state.modal;
